import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/shared/stores/authStore';

export default function RequirePermission({
  permission,
  children,
}: {
  permission: string;
  children: React.ReactNode;
}) {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  if (!hasPermission(permission)) {
    return <Navigate to="/admin" replace />;
  }
  return <>{children}</>;
}
